export default __webpack_public_path__ + "static/media/temp-1.8b3b3e63.svg";